import { render, staticRenderFns } from "./SubCategoryManagement.vue?vue&type=template&id=0b5d63ce&scoped=true"
import script from "./SubCategoryManagement.vue?vue&type=script&lang=js"
export * from "./SubCategoryManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5d63ce",
  null
  
)

export default component.exports